'use strict';

/**
 * @name position
 */

exports.getCity = require('./get-city.js');
